import React from "react";
import GerenciadorNFSe from "../../pages/notasFiscais/GerenciadorNFSe";
import EmissorNFSe from "../../pages/notasFiscais/EmissorNFSe";

const prefix = process.env.REACT_APP_PREFIX;

const notasFiscaisRoutes = [
  {
    path: `${prefix}/contabilidade/notaFiscal/NotaFiscal`,
    component: <GerenciadorNFSe />,
    title: "Gerenciador de notas",
  },
  {
    path: `${prefix}/contabilidade/notaFiscal/EmissorNotaFiscalServico/emissor`,
    component: <EmissorNFSe />,
    title: "emissor de NFS-e",
  },
];

export default notasFiscaisRoutes;
